import Section1 from '../components/ourstory/Section1' 
import Section2 from '../components/ourstory/Section2' 

 

function OurStory() {  
 

  return (

    <div className='bg-bgcolor font-font1'>
        <Section1 /> 
        <Section2/>
    </div>
   
  )
}

export default OurStory